import { render, staticRenderFns } from "./ProductEntitiesComparison.vue?vue&type=template&id=52276ce0&scoped=true&"
import script from "./ProductEntitiesComparison.vue?vue&type=script&lang=js&"
export * from "./ProductEntitiesComparison.vue?vue&type=script&lang=js&"
import style0 from "./ProductEntitiesComparison.vue?vue&type=style&index=0&id=52276ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52276ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSkeletonLoader})
